// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"A-f","block":"A-d7"};